export function utcTimestamp(value: string | number): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const normalized = /[zZ]|[+-]\d\d:\d\d$/.test(value) ? value : `${value.replace(' ', 'T')}Z`;
  const timestamp = Date.parse(normalized);
  return Number.isFinite(timestamp) ? timestamp : 0;
}

export function formatStudioDate(value: string | number, locale: 'en' | 'ru', timeZone: string): string {
  const timestamp = utcTimestamp(value);
  if (!timestamp) return '';
  return new Intl.DateTimeFormat(locale === 'ru' ? 'ru-RU' : 'en-US', locale === 'ru'
    ? { timeZone, day: '2-digit', month: '2-digit', year: 'numeric' }
    : { timeZone, month: 'short', day: 'numeric', year: 'numeric' }).format(timestamp);
}
